import React, { Component, createRef } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import Headers from './Header';
import NavigationBar from './Navigation';
import Loader from '../common/Loader';
import SessionType from '../common/SessionType';
import CheckMediaAccess from '../common/CheckMediaAccess';
import RecordingModal from '../common/RecordingModal';
import CheckNetworkConnection from '../common/CheckNetworkConnection';
import { showNotification } from '../../action/NotificationAction';
import {
    getVisitInformation,
    visitEnter,
    getSessionSummaryChatWithPagination,
} from '../../action/student/WaitingRoomAction';
import { PATH } from '../../../utils/Constants';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import { myLog } from '../../../utils/Utility';
import store from '../../../sessionStorage';
import { connectVideoCall } from '../../action/SocketActions';
// import profileImg from "../../../utils/images/profileImg.png";
import {
    attachmentSave,
    getUserById,
    removeImageFromSession,
} from '../../action/Admin/CommonAction';
import {
    BroadCastSession,
    ClassroomSession,
    Good,
    InPerson,
    OnDemand,
    Scheduled,
    Student,
    Unknown,
} from '../../../utils/common/NamingTerms';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';
import AppConfig from '../../../utils/common/DomainConfiguration';

const { detect } = require('detect-browser');
const browser = detect();

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class WaitingRoom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false,
            visitInfo: {},
            patientEmail: '',
            patientName: '',
            sessionStatus: '',
            sessionStudents: [],
            isLoading: false,
            isTabName: 'notes',
            uploadedImages: [],
            uploadComplaintImages: [],
            visitType: '',
            materialUploadedImages: [],
            countDown: '',
            time: '',
            chatMessage: [],
            chatLoading: false,
            addComplaintImage: false,
            isVideoOpen: false,
            videos: [],
            currentChatPage: 1,
            chatPerPage: 10,
            chatLastPage: 1,
        };
        this.chatContainerRef = createRef();
        this.networkChecker = new CheckNetworkConnection();
        this.mediaChecker = new CheckMediaAccess();
        this.networkChecker.browser = browser.name;
    }

    // componentDidMount
    componentDidMount() {
        this.timer = setInterval(() => {
            const { match } = this.props;
            this.invokeVisitInfo(match.params.visitId, false);
        }, 30000);
    }

    // componentDidUpdate
    componentDidUpdate(prevProps) {
        if (this.props.deactivateUserScreen !== prevProps.deactivateUserScreen) {
            clearInterval(this.timer);
        }
    }

    // componentWillMount
    componentWillMount() {
        const { match } = this.props;
        this.invokeVisitInfo(match.params.visitId, true);
    }

    // componentWillUnmount
    componentWillUnmount() {
        clearInterval(this.timer);
        clearInterval(this.interval);
    }

    //isLoading
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    // Fetch Session Summary
    invokeVisitInfo(visitId, initialCall) {
        this.isLoading();
        this.props.getVisitInformation(visitId, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                let optionDetails = [];
                if (response.response.sessionUsers && response.response.sessionUsers.length) {
                    response.response.sessionUsers.forEach((element) => {
                        let obj = {
                            label: element.name,
                            value: element.id,
                        };
                        optionDetails.push(obj);
                    });
                }
                this.setState(
                    {
                        visitInfo: response.response,
                        sessionStatus: response.response.sessionStatus,
                        isTabName:
                            response.response.sessionStatus === 'Note Pending' ? 'chat' : 'notes',
                        patientEmail: response.response.tutor?.email,
                        patientName: response.response.tutor?.name,
                        sessionStudents: response.response.sessionUsers,
                        uploadedImages: response.response.soapNote?.visitComplaintImages,
                        visitType: response.response.visitType,
                        materialUploadedImages: response.response.soapNote?.materialImages,
                        broadcast: response.response.activeSession?.broadcast,
                    },
                    () => {
                        if (
                            this.state.broadcast &&
                            this.state.broadcast?.hls &&
                            response.response.visitType === BroadCastSession
                        ) {
                            store.set('broadcastUrl', this.state.broadcast?.hls);
                        } else {
                            store.set('broadcastUrl', '');
                        }
                        if (
                            this.state.sessionStatus === 'Missed' ||
                            this.state.sessionStatus === 'Cancelled' ||
                            this.state.sessionStatus === 'Note Pending' ||
                            this.state.sessionStatus === 'Completed'
                        ) {
                            clearInterval(this.timer);
                        }
                        if (response.response.sessionStatus === 'Note Pending') {
                            this.setState({ chatLoading: true });
                            this.getSessionSummaryChatWithPagination(
                                this.state.visitInfo.id,
                                0,
                                this.state.chatPerPage
                            );
                        }
                        if (
                            response.response.visitType !== ClassroomSession &&
                            response.response.visitType !== BroadCastSession
                        ) {
                            this.setState({
                                patientUserId: response.response.tutee.userId
                                    ? response.response.tutee.userId
                                    : 0,
                            });
                            if (initialCall || this.state.visitType === OnDemand) {
                                if (response.response && response.response.isOnDemand) {
                                    if (response.response && response.response.visitStatus === 1) {
                                        if (
                                            response.response &&
                                            response.response.userCategory === 1 &&
                                            response.response.physicianAppointmentType === 0
                                        ) {
                                            this.setState({
                                                sessionStatus: 'Enter Virtual Class Room',
                                            });
                                        } else {
                                            this.setState({
                                                sessionStatus: Scheduled,
                                            });
                                        }
                                    }
                                    this.setState({ countDown: '0:00:00' });
                                }
                                if (this.state.visitInfo && this.state.visitInfo.isAppointment) {
                                    this.interval = setInterval(() => {
                                        this.setState({ time: Date.now() });
                                        let d1 = moment(
                                            this.state.visitInfo.appointment?.startTime
                                        );
                                        let d2 = moment(this.state.time);
                                        let ms = moment(d1, 'YYYYMMDD HH:mm:ss').diff(
                                            moment(d2, 'YYYYMMDD HH:mm:ss')
                                        );
                                        let d = moment.duration(ms);
                                        let ans =
                                            Math.floor(d.asHours()) +
                                            moment.utc(ms).format(':mm:ss');

                                        let end = moment(this.state.visitInfo.appointment?.endTime);

                                        if (
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isSameOrAfter(
                                                moment(d1, 'YYYYMMDD HH:mm:ss').subtract(
                                                    10,
                                                    'minute'
                                                )
                                            ) &&
                                            moment(d2, 'YYYYDDMM HH:mm:ss').isBefore(
                                                d1,
                                                'YYYYMMDD HH:mm:ss'
                                            )
                                        ) {
                                            if (this.state.visitInfo.visitStatus === 1) {
                                                if (
                                                    response.response &&
                                                    response.response.userCategory === 1 &&
                                                    response.response.physicianAppointmentType === 0
                                                ) {
                                                    this.setState({
                                                        sessionStatus: 'Enter Virtual Class Room',
                                                    });
                                                } else {
                                                    this.setState({
                                                        sessionStatus: Scheduled,
                                                    });
                                                }
                                            }
                                            this.setState({ countDown: ans });
                                        } else if (
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isBefore(
                                                moment(d1, 'YYYYMMDD HH:mm:ss')
                                            )
                                        ) {
                                            this.setState({ countDown: ans });
                                        } else if (
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isSameOrAfter(
                                                d1,
                                                'YYYYMMDD HH:mm:ss'
                                            ) &&
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isBefore(
                                                end,
                                                'YYYYMMDD HH:mm:ss'
                                            )
                                        ) {
                                            if (this.state.visitInfo.visitStatus === 1) {
                                                if (
                                                    response.response &&
                                                    response.response.userCategory === 1 &&
                                                    response.response.physicianAppointmentType === 0
                                                ) {
                                                    this.setState({
                                                        sessionStatus: 'Enter Virtual Class Room',
                                                    });
                                                } else {
                                                    this.setState({
                                                        sessionStatus: Scheduled,
                                                    });
                                                }
                                            }
                                            clearInterval(this.interval);
                                            this.setState({ countDown: '0:00:00' });
                                        } else {
                                            this.setState({ countDown: '0:00:00' });
                                        }
                                    }, 1000);
                                }
                            }
                        }
                    }
                );
                this.isLoading();
            } else if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                myLog('error');
            }
        });
    }

    /**
     * Handle video call
     */
    handleVideoCall = (type) => {
        sessionStorage.setItem('VISIT_TYPE', type);
        this.setState({ isLoading: true });
        const { match, connectVideoCall, visitInformation } = this.props;
        const visitId = match.params.visitId;
        this.props.getVisitInformation(visitId, (res) => {
            if (res.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({ isLoading: false });
                if (type === 'class_room') {
                    connectVideoCall(res.response);
                    this.props.history.push(
                        `${PATH.IM_PATIENT.VIDEO_CALL}/${
                            this.props.match.params.visitId
                        }/${Student}/${store.get('userSession').id}/classroom`
                    );
                } else if (type === 'broadcast') {
                    connectVideoCall(res.response);
                    this.props.history.push(
                        `${PATH.IM_PATIENT.VIDEO_CALL}/${
                            this.props.match.params.visitId
                        }/${Student}/${store.get('userSession').id}/broadcast`
                    );
                } else {
                    connectVideoCall(res.response.activeSession);
                    this.props.history.push(
                        `${PATH.IM_PATIENT.VIDEO_CALL}/${
                            this.props.match.params.visitId
                        }/${Student}/${store.get('userSession').id}`
                    );
                }
            } else {
                connectVideoCall(visitInformation.activeVisitSession);
            }
        });
    };

    /**
     * Change session status
     */
    handleVisitEnter = () => {
        this.setState({ statusClick: true });
        this.props.visitEnter(this.props.match.params.visitId, (res) => {
            this.setState({ statusClick: false });
            if (res.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({ sessionStatus: 'In Waiting Room' });
                this.invokeVisitInfo(this.props.match.params.visitId, false);
                this.props.showNotification(res.message, 'success');
            } else {
                this.props.showNotification(res.message, 'error');
            }
        });
    };

    //handleScroll
    handleScroll = () => {
        const chatContainer = this.chatContainerRef.current;
        const { scrollTop, scrollHeight, clientHeight } = chatContainer;
        if (scrollHeight <= Math.round(scrollTop) + clientHeight) {
            if (this.state.chatLastPage > this.state.currentChatPage) {
                this.getSessionSummaryChatWithPagination(
                    this.props.match.params.visitId,
                    this.state.currentChatPage,
                    this.state.chatPerPage
                );
                this.setState({
                    currentChatPage: this.state.currentChatPage + 1,
                });
            }
        }
    };

    // Fetch Session Summary Chat
    getSessionSummaryChatWithPagination(visitId, pageNumber, chatPerPage) {
        const values = {
            sort: 'asc',
            pageNumber: pageNumber + 1,
            itemsPerPage: chatPerPage,
            isSysNotificationReqd: true,
        };
        this.props.getSessionSummaryChatWithPagination(visitId, values, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    chatMessage: [...this.state.chatMessage, ...response.response.data.messages],
                    chatLoading: false,
                    chatLastPage: response.response.totalPages,
                });
            } else if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                myLog('error');
            }
        });
    }

    //preCallTest
    preCallTest = async () => {
        try {
            this.setState({ checkPermissionStatus: true });
            await this.mediaChecker.finalCheckingPermission();
            if (
                this.mediaChecker.state.cameraGranted &&
                this.mediaChecker.state.microphoneGranted &&
                !this.mediaChecker.state.systemCameraBlocked &&
                !this.mediaChecker.state.systemMicrophoneBlocked
            ) {
                const networkGood =
                    this.networkChecker.browser === 'firefox' ||
                    this.networkChecker.browser === 'safari'
                        ? await this.networkChecker.checkfirefoxNetworkSignal()
                        : await this.networkChecker.checkNetworkSignal();

                if (
                    networkGood &&
                    (this.networkChecker.state.networkQuality === Good ||
                        this.networkChecker.state.networkQuality === Unknown)
                ) {
                    console.log(
                        'Network and media checks passed, joining session with quality:',
                        this.networkChecker.state.networkQuality
                    );
                    this.handleVideoCall(
                        this.state.visitType === ClassroomSession
                            ? 'class_room'
                            : this.state.visitType === BroadCastSession
                              ? 'broadcast'
                              : 'one_to_one'
                    );
                } else {
                    console.log(
                        'Session join blocked. Network quality:',
                        this.networkChecker.state.networkQuality,
                        'Network good:',
                        networkGood
                    );
                    this.setState({ checkPermissionStatus: false });
                }
            } else {
                this.setState({ checkPermissionStatus: false });
            }
        } catch (error) {
            console.log('error: ', error);
        }
    };

    formatText(text) {
        if (!text) return '';
        let formattedText = text.replace(/\*/g, '');
        formattedText = formattedText
            .split('\n')
            .map((line) => line.trim())
            .join('\n');
        return formattedText;
    }

    // Render Appointment Status Button
    renderAppointmentStatusButton(status) {
        if (/Missed$/i.test(status)) {
            const missedText =
                status === 'Team Member Missed'
                    ? this.props.t('teamMemberMissed')
                    : status === 'Owner Missed'
                      ? this.props.t('ownerMissed')
                      : status === 'Doctor Missed'
                        ? this.props.t('doctorMissed')
                        : status;
            return (
                <button
                    type="button"
                    className="border rounded-lg font-medium text-base px-4 py-1.5 text-red border-red cursor-auto"
                >
                    {missedText}
                </button>
            );
        } else {
            switch (status) {
                case 'Booked':
                case Scheduled:
                    return (
                        <button
                            type="button"
                            className="border rounded-lg font-medium text-base px-4 py-1.5 text-emerald border-emerald cursor-auto"
                        >
                            {this.props.t('scheduled')}
                        </button>
                    );
                case 'In Waiting Room':
                    return (
                        <button
                            type="button"
                            className="border rounded-lg font-medium text-base px-4 py-1.5 text-gray border-gray cursor-auto"
                        >
                            {this.props.t('inWaitingRoom')}
                        </button>
                    );
                case 'Enter Virtual Class Room':
                    return (
                        <button
                            type="button"
                            className="border rounded-lg font-medium text-base px-4 py-1.5 text-emerald border-emerald"
                            style={{
                                pointerEvents:
                                    this.state.visitType === ClassroomSession ? 'none' : '',
                            }}
                            disabled={this.state.statusClick}
                            onClick={() => {
                                this.handleVisitEnter();
                            }}
                        >
                            {this.props.t('enterSession')}
                        </button>
                    );
                case 'Visit In Call':
                    return (
                        <button
                            type="button"
                            className="border rounded-lg font-medium text-base px-4 py-1.5 text-emerald border-emerald"
                            onClick={this.preCallTest}
                        >
                            {!this.state.visitInfo?.joined
                                ? this.props.t('joinTheSession')
                                : this.props.t('resumeYourSession')}
                        </button>
                    );
                case 'Completed':
                    return (
                        <button
                            type="button"
                            className="border rounded-lg font-medium text-base px-4 py-1.5 text-success border-success cursor-auto"
                        >
                            {this.props.t('completed')}
                        </button>
                    );
                case 'Pending':
                    return (
                        <button
                            type="button"
                            className="border rounded-lg font-medium text-base px-4 py-1.5 text-warning border-warning cursor-auto"
                        >
                            {this.props.t('pending')}
                        </button>
                    );
                case 'Note Pending':
                    return (
                        <button
                            type="button"
                            className="rounded-lg font-medium text-white px-4 py-1.5 bg-notespending cursor-auto"
                        >
                            {this.props.t('notePending')}
                        </button>
                    );
                case 'Removed':
                    return (
                        <button
                            type="button"
                            className="border rounded-lg font-medium text-base px-4 py-1.5 text-red border-red cursor-auto"
                        >
                            {this.props.t('removed')}
                        </button>
                    );
                case 'Cancelled':
                    return (
                        <button
                            type="button"
                            className="border rounded-lg font-medium text-base px-4 py-1.5 text-red border-red cursor-auto"
                        >
                            {this.props.t('cancelled')}
                        </button>
                    );
                default:
                    return <div />;
            }
        }
    }

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    // Upload Images on  session summary
    complaintImages = (event) => {
        this.setState({ addComplaintImage: true });
        const files = event.target.files;
        const readerPromises = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (
                file.type === 'image/png' ||
                file.type === 'image/jpeg' ||
                file.type === 'image/jpg' ||
                file.type === 'application/pdf'
            ) {
                if (file.size <= 10485760) {
                    const reader = new FileReader();
                    readerPromises.push(
                        new Promise((resolve) => {
                            reader.onloadend = () => {
                                const base64 = reader.result;
                                resolve(base64);
                            };
                            reader.readAsDataURL(file);
                        })
                    );
                } else {
                    this.props.showNotification.error(
                        RESPONSE_CONSTANT.MEDIA_FILE_SIZE,
                        RESPONSE_CONSTANT.WARNING
                    );
                    return;
                }
            } else {
                this.props.showNotification.error(
                    RESPONSE_CONSTANT.UPLOAD_ONLY_IMAGE,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
        }
        Promise.all(readerPromises).then((base64Results) => {
            this.setState({ uploadComplaintImages: base64Results }, () => {
                this.updateComplaintImages();
            });
        });
    };

    // attachment api for image update on session summary
    updateComplaintImages = () => {
        this.props.attachmentSave(
            this.props.match.params.visitId,
            this.state.uploadComplaintImages,
            (result) => {
                if (result) {
                    if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.invokeVisitInfo(this.props.match.params.visitId, true);
                        this.props.showNotification(result.message, 'success');
                    } else {
                        this.props.showNotification(result.message, 'error');
                    }
                } else {
                    this.props.showNotification('Image not Saved', 'error');
                    return;
                }
                this.setState({ addComplaintImage: false });
            }
        );
    };

    // remove img on session summary
    removeComplaintImages = (id) => {
        this.props.removeImageFromSession(id, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                this.invokeVisitInfo(this.props.match.params.visitId, true);
            } else {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
            }
        });
    };

    /**
     * Render page
     */
    render() {
        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PATIENT.APPOINTMENT}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow">
                    <Headers
                        {...this.props}
                        title={this.props.t('sessionSummary')}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                        <div className="items-center justify-between px-4 sm:flex sm:px-8">
                            <h6 className="m-0 text-lg font-semibold text-white">
                                {this.props.t('sessionSummary')}
                            </h6>
                        </div>
                        {this.state.isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className="flex flex-row flex-grow px-4 mt-6 sm:px-8">
                                    <div className="flex flex-col w-full p-6 rounded-lg bg-card">
                                        {!this.state.summary && (
                                            <div className="flex items-baseline justify-end mb-6 mobile-session-status">
                                                {this.renderAppointmentStatusButton(
                                                    this.state.sessionStatus
                                                )}
                                            </div>
                                        )}
                                        <div className="w-full">
                                            <div className="items-center pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('sessionType')}
                                                </h6>
                                                <SessionType
                                                    sessionType={this.state.visitInfo.sessionType}
                                                />
                                                <div className="flex items-baseline justify-end web-session-status">
                                                    {this.renderAppointmentStatusButton(
                                                        this.state.sessionStatus
                                                    )}
                                                </div>
                                            </div>
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('ownerName')}
                                                </h6>
                                                <h6
                                                    className="text-[#F6F8FB]"
                                                    title={this.state.patientName}
                                                >
                                                    {this.state.patientName &&
                                                    this.state.patientName.length > 25
                                                        ? `${this.state.patientName.slice(0, 25)}...`
                                                        : (this.state.patientName ??
                                                          RESPONSE_CONSTANT.HYPHEN)}
                                                </h6>
                                            </div>
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t(`${AppConfig.labels.channelName}`)}
                                                </h6>
                                                <h6 className="text-[#F6F8FB]">
                                                    {this.state.visitInfo.expertiseCategory
                                                        ? this.state.visitInfo.expertiseCategory
                                                        : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                </h6>
                                            </div>
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('element')}
                                                </h6>
                                                <h6 className="text-[#F6F8FB]">
                                                    {' '}
                                                    {this.state.visitInfo.expertise
                                                        ? this.state.visitInfo.expertise
                                                        : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                </h6>
                                            </div>
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('dateOfSession')}
                                                </h6>
                                                <h6 className="text-[#F6F8FB]">
                                                    {this.state.visitInfo.sessionType ? (
                                                        <>
                                                            {this.state.visitInfo.isOnDemand ||
                                                            this.state.visitInfo.sessionType ===
                                                                ClassroomSession ||
                                                            this.state.visitInfo.visitType ===
                                                                InPerson ||
                                                            this.state.visitInfo.visitType ===
                                                                BroadCastSession
                                                                ? this.state.visitInfo.onDemand &&
                                                                  moment(
                                                                      this.state.visitInfo.onDemand
                                                                          .startTime
                                                                  ).format('MMM DD, YYYY')
                                                                : this.state.visitInfo
                                                                      .appointment &&
                                                                  moment(
                                                                      this.state.visitInfo
                                                                          .appointment.startTime
                                                                  ).format('MMM DD, YYYY')}
                                                        </>
                                                    ) : (
                                                        RESPONSE_CONSTANT.HYPHEN
                                                    )}
                                                </h6>
                                            </div>
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('timeOfSession')}
                                                </h6>
                                                <h6 className="text-[#F6F8FB]">
                                                    {this.state.visitInfo.sessionType ? (
                                                        <>
                                                            {this.state.visitInfo.isOnDemand ||
                                                            this.state.visitInfo.sessionType ===
                                                                ClassroomSession ||
                                                            this.state.visitInfo.visitType ===
                                                                InPerson ||
                                                            this.state.visitInfo.visitType ===
                                                                BroadCastSession
                                                                ? this.state.visitInfo.onDemand &&
                                                                  moment(
                                                                      this.state.visitInfo.onDemand
                                                                          .startTime
                                                                  ).format('hh:mm A')
                                                                : this.state.visitInfo
                                                                      .appointment &&
                                                                  moment(
                                                                      this.state.visitInfo
                                                                          .appointment.startTime
                                                                  ).format('hh:mm A')}
                                                            {` ${this.props.t('to')} `}
                                                            {this.state.visitInfo.isOnDemand ||
                                                            this.state.visitInfo.sessionType ===
                                                                ClassroomSession ||
                                                            this.state.visitInfo.visitType ===
                                                                InPerson ||
                                                            this.state.visitInfo.visitType ===
                                                                BroadCastSession
                                                                ? this.state.visitInfo.onDemand &&
                                                                  moment(
                                                                      this.state.visitInfo.onDemand
                                                                          .endTime
                                                                  ).format('hh:mm A')
                                                                : this.state.visitInfo
                                                                      .appointment &&
                                                                  moment(
                                                                      this.state.visitInfo
                                                                          .appointment.endTime
                                                                  ).format('hh:mm A')}
                                                        </>
                                                    ) : (
                                                        RESPONSE_CONSTANT.HYPHEN
                                                    )}
                                                </h6>
                                            </div>
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('additionalSummary')}
                                                </h6>
                                                <h6 className="break-words text-[#F6F8FB]">
                                                    {this.state.visitInfo.comments
                                                        ? this.state.visitInfo.comments
                                                        : RESPONSE_CONSTANT.HYPHEN}
                                                </h6>
                                            </div>
                                            <div
                                                className={`sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0 ${
                                                    this.state.visitInfo?.recordingUrl &&
                                                    (this.state.sessionStatus === 'Note Pending' ||
                                                        this.state.sessionStatus === 'Completed')
                                                        ? 'pb-6'
                                                        : RESPONSE_CONSTANT.EMPTY
                                                }`}
                                            >
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('uploadedImagesPDF')}
                                                </h6>
                                                <div className="flex flex-row flex-wrap w-auto gap-3 mt-4 bg-transparent rounded-lg sm:mt-0 max-w-fit mw-48">
                                                    {this.state.uploadedImages &&
                                                    this.state.uploadedImages.length
                                                        ? this.state.uploadedImages.map(
                                                              (res, index) => (
                                                                  <div
                                                                      className="relative upload"
                                                                      key={index}
                                                                  >
                                                                      {this.state.visitInfo
                                                                          ?.allowAddImage &&
                                                                          this.state.visitInfo
                                                                              ?.createdByRole ===
                                                                              'Student' && (
                                                                              <span
                                                                                  className="cursor-pointer fas fa-times-circle text-red"
                                                                                  style={{
                                                                                      position:
                                                                                          'absolute',
                                                                                      right: '-5px',
                                                                                      top: '-5px',
                                                                                  }}
                                                                                  onClick={() => {
                                                                                      this.removeComplaintImages(
                                                                                          res.id
                                                                                      );
                                                                                  }}
                                                                              ></span>
                                                                          )}
                                                                      {res.fileType === 'pdf' ? (
                                                                          <div
                                                                              key={index}
                                                                              className="border border-[#34373E]"
                                                                          >
                                                                              <a
                                                                                  href={res.image}
                                                                                  target="_blank"
                                                                                  rel="noopener noreferrer"
                                                                                  onClick={(e) => {
                                                                                      e.preventDefault();
                                                                                      const userId =
                                                                                          store.get(
                                                                                              'bloomIfAI_id'
                                                                                          );
                                                                                      this.props.getUserById(
                                                                                          userId,
                                                                                          (
                                                                                              response
                                                                                          ) => {
                                                                                              if (
                                                                                                  response
                                                                                              ) {
                                                                                                  window.open(
                                                                                                      res.image,
                                                                                                      '_blank'
                                                                                                  );
                                                                                              } else {
                                                                                                  console.error(
                                                                                                      this.props.t(
                                                                                                          'failedToFetchUserDetails'
                                                                                                      )
                                                                                                  );
                                                                                              }
                                                                                          }
                                                                                      );
                                                                                  }}
                                                                              >
                                                                                  <i
                                                                                      className="fa-solid fa-file-pdf"
                                                                                      style={{
                                                                                          color: '#c30909',
                                                                                          width: '5rem',
                                                                                          height: '5rem',
                                                                                          borderRadius:
                                                                                              '0.25rem',
                                                                                          fontSize:
                                                                                              '70px',
                                                                                          display:
                                                                                              'flex',
                                                                                          justifyContent:
                                                                                              'center',
                                                                                          alignItems:
                                                                                              'center',
                                                                                      }}
                                                                                  ></i>
                                                                              </a>
                                                                          </div>
                                                                      ) : (
                                                                          <a
                                                                              href={res.image}
                                                                              target="_blank"
                                                                              rel="noopener noreferrer"
                                                                              onClick={(e) => {
                                                                                  e.preventDefault();
                                                                                  const userId =
                                                                                      store.get(
                                                                                          'bloomIfAI_id'
                                                                                      );
                                                                                  this.props.getUserById(
                                                                                      userId,
                                                                                      (
                                                                                          response
                                                                                      ) => {
                                                                                          if (
                                                                                              response
                                                                                          ) {
                                                                                              window.open(
                                                                                                  res.image,
                                                                                                  '_blank'
                                                                                              );
                                                                                          } else {
                                                                                              console.error(
                                                                                                  this.props.t(
                                                                                                      'failedToFetchUserDetails'
                                                                                                  )
                                                                                              );
                                                                                          }
                                                                                      }
                                                                                  );
                                                                              }}
                                                                          >
                                                                              <img
                                                                                  src={res.image}
                                                                                  className="w-20 h-20 rounded"
                                                                                  key={index}
                                                                                  alt=""
                                                                              />
                                                                          </a>
                                                                      )}
                                                                  </div>
                                                              )
                                                          )
                                                        : ((this.state.visitInfo.onDemand &&
                                                              !this.state.visitInfo
                                                                  ?.allowAddImage) ||
                                                              (!this.state.visitInfo.onDemand &&
                                                                  this.state.visitInfo
                                                                      ?.createdByRole !==
                                                                      'Student' &&
                                                                  !this.state.visitInfo
                                                                      ?.allowAddImage)) && (
                                                              <div className="flex flex-row w-auto gap-3 mt-3 text-[#F6F8FB] max-w-fit sm:mt-0">
                                                                  -
                                                              </div>
                                                          )}
                                                    {this.state.visitInfo?.allowAddImage &&
                                                        this.state.visitInfo?.createdByRole ===
                                                            'Student' && (
                                                            <div className="flex justify-center w-20 h-20 rounded bg-dateselect border border-[#34373E]">
                                                                <div className="flex text-center">
                                                                    <input
                                                                        type="file"
                                                                        multiple
                                                                        id="file-upload"
                                                                        name="file-upload"
                                                                        className="sr-only"
                                                                        onClick={(e) => {
                                                                            e.target.value = null;
                                                                        }}
                                                                        disabled={
                                                                            this.state
                                                                                .addComplaintImage
                                                                        }
                                                                        onChange={
                                                                            this.complaintImages
                                                                        }
                                                                        accept=".png,.jpeg,.jpg,.pdf"
                                                                    />
                                                                    <label
                                                                        htmlFor="file-upload"
                                                                        className={`relative ${
                                                                            this.state
                                                                                .addComplaintImage
                                                                                ? ''
                                                                                : 'cursor-pointer'
                                                                        } flex items-center justify-center`}
                                                                    >
                                                                        <span className="text-white">
                                                                            <i className="fas fa-plus-circle fa-2x text-iconcolor"></i>
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                            {this.state.visitInfo?.recordingUrl &&
                                                (this.state.sessionStatus === 'Note Pending' ||
                                                    this.state.sessionStatus === 'Completed') && (
                                                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                        <h6 className="font-medium text-white">
                                                            {this.props.t('recordings')}
                                                        </h6>
                                                        <i
                                                            onClick={() => {
                                                                const userId =
                                                                    store.get('bloomIfAI_id');
                                                                this.props.getUserById(
                                                                    userId,
                                                                    (response) => {
                                                                        if (response) {
                                                                            console.log(
                                                                                'User details fetched successfully:',
                                                                                response
                                                                            );
                                                                        } else {
                                                                            console.error(
                                                                                this.props.t(
                                                                                    'failedToFetchUserDetails'
                                                                                )
                                                                            );
                                                                        }
                                                                    }
                                                                );
                                                                this.setState({
                                                                    isVideoOpen: true,
                                                                    videos: this.state.visitInfo
                                                                        ?.recordingUrls,
                                                                });
                                                            }}
                                                            className="cursor-pointer fab fa-youtube fa-lg text-iconcolor"
                                                        ></i>
                                                    </div>
                                                )}
                                            <div className="flex justify-end">
                                                <p className="text-UInew">
                                                    {this.props.t('createdTime')} :{' '}
                                                    {this.state.visitInfo.sessionType ? (
                                                        <>
                                                            {this.state.visitInfo.isOnDemand ||
                                                            this.state.visitInfo.sessionType ===
                                                                ClassroomSession ||
                                                            this.state.visitInfo.visitType ===
                                                                InPerson ||
                                                            this.state.visitInfo.visitType ===
                                                                BroadCastSession
                                                                ? this.state.visitInfo.onDemand &&
                                                                  moment(
                                                                      this.state.visitInfo.onDemand
                                                                          .appointmentDate
                                                                  )
                                                                      .locale(this.props.language || 'en')
                                                                      .format(
                                                                          this.props.language === 'es'
                                                                              ? 'D [de] MMMM [de] YYYY, h:mm a'
                                                                              : 'MMM DD, YYYY hh:mm A'
                                                                      )
                                                                : this.state.visitInfo
                                                                      .appointment &&
                                                                  moment(
                                                                      this.state.visitInfo
                                                                          .appointment
                                                                          .appointmentDate
                                                                  )
                                                                      .locale(this.props.language || 'en')
                                                                      .format(
                                                                          this.props.language === 'es'
                                                                              ? 'D [de] MMMM [de] YYYY, h:mm a'
                                                                              : 'MMM DD, YYYY hh:mm A'
                                                                      )}
                                                        </>
                                                    ) : (
                                                        '-'
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.sessionStatus === 'Completed' ||
                                this.state.sessionStatus === 'Note Pending' ? (
                                    <div className="flex flex-row flex-grow px-4 mt-6 sm:px-8">
                                        <div className="flex flex-col w-full p-6 rounded-lg bg-card">
                                            <nav className="flex flex-col gap-4 mb-6 sm:flex-row border-b border-[#34373E]">
                                                {this.state.sessionStatus === 'Completed' && (
                                                    <button
                                                        className={
                                                            this.state.isTabName === 'notes'
                                                                ? 'text-UIprimary font-medium text-base px-3 block hover:text-UIprimary focus:outline-none border-b-2 pb-2'
                                                                : 'text-UIsecondary text-base font-normal block focus:outline-none pb-2'
                                                        }
                                                        onClick={() =>
                                                            this.setState({ isTabName: 'notes' })
                                                        }
                                                    >
                                                        {this.props.t('viewSessionNotes')}
                                                    </button>
                                                )}
                                                {this.state.visitInfo.sessionType !== InPerson && (
                                                    <button
                                                        className={
                                                            this.state.isTabName === 'chat'
                                                                ? 'text-UIprimary font-medium text-base px-3 block hover:text-UIprimary focus:outline-none border-b-2 pb-2'
                                                                : 'text-UIsecondary text-base font-normal block focus:outline-none pb-2'
                                                        }
                                                        onClick={() => {
                                                            this.setState({
                                                                isTabName: 'chat',
                                                                chatLoading: true,
                                                                chatMessage: [],
                                                                chatLastPage: 1,
                                                                currentChatPage: 1,
                                                            });
                                                            this.getSessionSummaryChatWithPagination(
                                                                this.state.visitInfo.id,
                                                                0,
                                                                this.state.chatPerPage
                                                            );
                                                        }}
                                                    >
                                                        {this.props.t('viewChat')}
                                                    </button>
                                                )}
                                            </nav>
                                            <div id="Tab_session_notes">
                                                {this.state.isTabName === 'notes' ? (
                                                    <div
                                                        className="overflow-x-auto rounded-lg"
                                                        id="notes"
                                                        role="tabpanel"
                                                        aria-labelledby="notes-tab"
                                                    >
                                                        <div className="grid sm:grid-cols-2">
                                                            <div className="order-last mb-6 sm:order-first">
                                                                <label
                                                                    htmlFor="select-about"
                                                                    className="block mb-2 font-normal text-white"
                                                                >
                                                                    {this.props.t(`${AppConfig.labels.channelName}`)}
                                                                </label>
                                                                <textarea
                                                                    id="about"
                                                                    name="about"
                                                                    rows="3"
                                                                    maxLength="300"
                                                                    disabled={true}
                                                                    value={
                                                                        this.props.visitDetails
                                                                            ?.soapNote?.subjective
                                                                    }
                                                                    placeholder={this.props.t('noChannelNotesFound')}
                                                                    className="block w-full p-2 text-white rounded resize-none bg-dateselect placeholder:text-secondary sm:text-base"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="grid sm:grid-cols-2">
                                                            <div className="order-last mb-6 sm:order-first">
                                                                <label
                                                                    htmlFor="select-about"
                                                                    className="block mb-2 text-base font-normal text-white"
                                                                >
                                                                    {this.props.t('sessionNotes')}
                                                                </label>
                                                                <textarea
                                                                    id="about"
                                                                    name="about"
                                                                    rows="10"
                                                                    maxLength="300"
                                                                    disabled={true}
                                                                    value={this.formatText(
                                                                        this.props.visitDetails
                                                                            ?.soapNote?.objective
                                                                    )}
                                                                    placeholder={this.props.t('noSessionNotesFound')}
                                                                    className="block w-full p-2 text-white rounded resize-none bg-dateselect placeholder:text-secondary sm:text-base"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="grid sm:grid-cols-2">
                                                            <div className="order-last mb-6 sm:order-first">
                                                                <label
                                                                    htmlFor="select-about"
                                                                    className="block mb-2 text-base font-normal text-white"
                                                                >
                                                                    {this.props.t('materialImagesPDF')}
                                                                </label>
                                                                {this.state
                                                                    .materialUploadedImages &&
                                                                this.state.materialUploadedImages
                                                                    .length ? (
                                                                    <div className="flex flex-row flex-wrap w-auto gap-3 mt-3 rounded-lg bg-dateselect max-w-fit sm:mt-0 min-width-50">
                                                                        {this.state.materialUploadedImages.map(
                                                                            (res, index) => {
                                                                                return (
                                                                                    <div
                                                                                        key={index}
                                                                                        className="border border-[#34373E]"
                                                                                    >
                                                                                        {res?.fileType ===
                                                                                        'pdf' ? (
                                                                                            <a
                                                                                                href={
                                                                                                    res.image
                                                                                                }
                                                                                                target="_blank"
                                                                                                rel="noopener noreferrer"
                                                                                                onClick={(
                                                                                                    e
                                                                                                ) => {
                                                                                                    e.preventDefault();
                                                                                                    const userId =
                                                                                                        store.get(
                                                                                                            'bloomIfAI_id'
                                                                                                        );
                                                                                                    this.props.getUserById(
                                                                                                        userId,
                                                                                                        (
                                                                                                            response
                                                                                                        ) => {
                                                                                                            if (
                                                                                                                response
                                                                                                            ) {
                                                                                                                window.open(
                                                                                                                    res.image,
                                                                                                                    '_blank'
                                                                                                                );
                                                                                                            } else {
                                                                                                                console.error(
                                                                                                                    this.props.t(
                                                                                                                        'failedToFetchUserDetails'
                                                                                                                    )
                                                                                                                );
                                                                                                            }
                                                                                                        }
                                                                                                    );
                                                                                                }}
                                                                                            >
                                                                                                <i
                                                                                                    className="fa-solid fa-file-pdf"
                                                                                                    style={{
                                                                                                        backgroundColor:
                                                                                                            '#ede8e8',
                                                                                                        color: '#c30909',
                                                                                                        width: '5rem',
                                                                                                        height: '5rem',
                                                                                                        borderRadius:
                                                                                                            '0.25rem',
                                                                                                        fontSize:
                                                                                                            '70px',
                                                                                                        display:
                                                                                                            'flex',
                                                                                                        justifyContent:
                                                                                                            'center',
                                                                                                        alignItems:
                                                                                                            'center',
                                                                                                    }}
                                                                                                ></i>
                                                                                            </a>
                                                                                        ) : (
                                                                                            <a
                                                                                                href={
                                                                                                    res.image
                                                                                                }
                                                                                                target="_blank"
                                                                                                rel="noopener noreferrer"
                                                                                                onClick={(
                                                                                                    e
                                                                                                ) => {
                                                                                                    e.preventDefault();
                                                                                                    const userId =
                                                                                                        store.get(
                                                                                                            'bloomIfAI_id'
                                                                                                        );
                                                                                                    this.props.getUserById(
                                                                                                        userId,
                                                                                                        (
                                                                                                            response
                                                                                                        ) => {
                                                                                                            if (
                                                                                                                response
                                                                                                            ) {
                                                                                                                window.open(
                                                                                                                    res.image,
                                                                                                                    '_blank'
                                                                                                                );
                                                                                                            } else {
                                                                                                                console.error(
                                                                                                                    this.props.t(
                                                                                                                        'failedToFetchUserDetails'
                                                                                                                    )
                                                                                                                );
                                                                                                            }
                                                                                                        }
                                                                                                    );
                                                                                                }}
                                                                                            >
                                                                                                <img
                                                                                                    src={
                                                                                                        res.image
                                                                                                    }
                                                                                                    className="w-20 h-20 rounded border-black-10"
                                                                                                    key={
                                                                                                        index
                                                                                                    }
                                                                                                    alt=""
                                                                                                />
                                                                                            </a>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <textarea
                                                                        id="about"
                                                                        name="about"
                                                                        rows="3"
                                                                        maxLength="300"
                                                                        disabled={true}
                                                                        placeholder={this.props.t('noMaterialImagesFound')}
                                                                        className="block w-full p-2 text-white rounded resize-none bg-dateselect placeholder:text-secondary sm:text-base"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="grid sm:grid-cols-2">
                                                            <div className="order-last sm:order-first">
                                                                <label
                                                                    htmlFor="select-about"
                                                                    className="block mb-2 text-base font-normal text-white"
                                                                >
                                                                    {this.props.t('recommendations')}
                                                                </label>
                                                                <textarea
                                                                    id="about"
                                                                    name="about"
                                                                    rows="3"
                                                                    maxLength="300"
                                                                    disabled={true}
                                                                    value={
                                                                        this.props.visitDetails
                                                                            ?.soapNote?.plan
                                                                    }
                                                                    placeholder={this.props.t('noRecommendationsFound')}
                                                                    className="block w-full p-2 text-white rounded resize-none bg-dateselect placeholder:text-secondary sm:text-base"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="pr-4 overflow-auto rounded-lg chat-height"
                                                        id="chat"
                                                        role="tabpanel"
                                                        aria-labelledby="chat-tab"
                                                        ref={this.chatContainerRef}
                                                        onScroll={() => this.handleScroll()}
                                                    >
                                                        <>
                                                            {this.state.chatLoading ? (
                                                                <Loader />
                                                            ) : (
                                                                <>
                                                                    {this.state.chatMessage &&
                                                                    this.state.chatMessage
                                                                        .length ? (
                                                                        <>
                                                                            {/* eslint-disable array-callback-return  */}
                                                                            {this.state.chatMessage.map(
                                                                                (res, index) => {
                                                                                    if (
                                                                                        res.messageType ===
                                                                                        0
                                                                                    ) {
                                                                                        if (
                                                                                            res.senderUserId ===
                                                                                            store.get(
                                                                                                'userSession'
                                                                                            ).id
                                                                                        ) {
                                                                                            return (
                                                                                                <div
                                                                                                    className="flex flex-row-reverse pb-6 md:pb-4"
                                                                                                    key={
                                                                                                        index
                                                                                                    }
                                                                                                >
                                                                                                    <div className="ml-3 msg-profile">
                                                                                                        {/* <img
                                                      className="rounded-full bg-teal border-black-10 w-14 h-14"
                                                      src={
                                                        res.senderImage
                                                          ? res.senderImage
                                                          : profileImg
                                                      }
                                                      alt=""
                                                    /> */}
                                                                                                    </div>
                                                                                                    <div className="msg-text">
                                                                                                        <div className="p-3 mt-2 text-white rounded bg-cyan overflow-anywhere whitespace-pre-wrap break-words">
                                                                                                            {res.message
                                                                                                                .split(
                                                                                                                    /\n/
                                                                                                                )
                                                                                                                .map(
                                                                                                                    (
                                                                                                                        message
                                                                                                                    ) => (
                                                                                                                        <div
                                                                                                                            key={
                                                                                                                                message
                                                                                                                            }
                                                                                                                            title={
                                                                                                                                message
                                                                                                                            }
                                                                                                                        >
                                                                                                                            {
                                                                                                                                message
                                                                                                                            }
                                                                                                                            <br />
                                                                                                                        </div>
                                                                                                                    )
                                                                                                                )}
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="flex items-end justify-end text-white ms-2"
                                                                                                            style={{
                                                                                                                fontSize:
                                                                                                                    '10px',
                                                                                                            }}
                                                                                                        >
                                                                                                            {moment(
                                                                                                                res.created
                                                                                                            ).format(
                                                                                                                'hh:mm A'
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            );
                                                                                        } else {
                                                                                            return (
                                                                                                <div
                                                                                                    className="flex pb-6 md:pb-4"
                                                                                                    key={
                                                                                                        index
                                                                                                    }
                                                                                                >
                                                                                                    <div className="mr-3 msg-profile">
                                                                                                        {/* <img
                                                      className="rounded-full bg-teal border-black-10 w-14 h-14"
                                                      src={
                                                        res.senderImage
                                                          ? res.senderImage
                                                          : profileImg
                                                      }
                                                      alt=""
                                                    /> */}
                                                                                                    </div>
                                                                                                    <div className="msg-text">
                                                                                                        <div className="text-left">
                                                                                                            <span
                                                                                                                className="mr-2 font-medium text-white"
                                                                                                                title={
                                                                                                                    res.senderName
                                                                                                                }
                                                                                                            >
                                                                                                                {res
                                                                                                                    .senderName
                                                                                                                    .length >
                                                                                                                25
                                                                                                                    ? `${res.senderName.slice(
                                                                                                                          0,
                                                                                                                          25
                                                                                                                      )}...`
                                                                                                                    : res.senderName}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div className="p-3 mt-2 text-white rounded bg-black/10 overflow-anywhere whitespace-pre-wrap break-words">
                                                                                                            {res.message
                                                                                                                .split(
                                                                                                                    /\n/
                                                                                                                )
                                                                                                                .map(
                                                                                                                    (
                                                                                                                        message
                                                                                                                    ) => (
                                                                                                                        <div
                                                                                                                            key={
                                                                                                                                message
                                                                                                                            }
                                                                                                                            title={
                                                                                                                                message
                                                                                                                            }
                                                                                                                        >
                                                                                                                            {
                                                                                                                                message
                                                                                                                            }
                                                                                                                            <br />
                                                                                                                        </div>
                                                                                                                    )
                                                                                                                )}
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="flex items-end justify-end text-white ms-2"
                                                                                                            style={{
                                                                                                                fontSize:
                                                                                                                    '10px',
                                                                                                            }}
                                                                                                        >
                                                                                                            {moment(
                                                                                                                res.created
                                                                                                            ).format(
                                                                                                                'hh:mm A'
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                    } else if (
                                                                                        res.messageType ===
                                                                                        2
                                                                                    ) {
                                                                                        return (
                                                                                            <div className="flex justify-center">
                                                                                                <div
                                                                                                    className="px-2 py-1 mt-2 mb-2 text-center rounded-lg text-secondary bg-neutral"
                                                                                                    style={{
                                                                                                        fontSize: 12,
                                                                                                    }}
                                                                                                >
                                                                                                    {
                                                                                                        res.message
                                                                                                    }{' '}
                                                                                                    at{' '}
                                                                                                    {moment(
                                                                                                        res.created
                                                                                                    ).format(
                                                                                                        'hh:mm A'
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                }
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <div className="flex items-center justify-center text-white">
                                                                            {this.props.t('noChatFound')}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </>
                        )}
                    </div>
                </main>
                <RecordingModal
                    isVideoOpen={this.state.isVideoOpen}
                    videos={this.state.videos}
                    closeModal={() => {
                        this.setState({
                            isVideoOpen: false,
                            videos: [],
                        });
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        visitDetails: state.PatientVisitInformationReducer.VisitInformation,
        deactivateUserScreen: state.NetworkInState.deactivateUserScreen,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getVisitInformation: (visitId, callBack) => {
            dispatch(getVisitInformation(visitId, callBack));
        },
        getSessionSummaryChatWithPagination: (visitId, values, callBack) => {
            dispatch(getSessionSummaryChatWithPagination(visitId, values, callBack));
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        connectVideoCall: (data) => {
            dispatch(connectVideoCall(data));
        },
        visitEnter: (visitId, callback) => {
            dispatch(visitEnter(visitId, callback));
        },
        removeImageFromSession: (id, callback) => {
            dispatch(removeImageFromSession(id, callback));
        },
        attachmentSave: (id, photo, callback) => {
            dispatch(attachmentSave(id, photo, callback));
        },
        getUserById: (userId, callBack) => {
            dispatch(getUserById(userId, callBack));
        },
    };
};

const ConnectedWaitingRoom = withLanguage(
    connect(mapStateToProps, mapDispatchToProps)(WaitingRoom)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedWaitingRoom {...props} />
    </LanguageProvider>
);
